import { DendromapLoader } from '@repo/ui/components/dendromap-loader';
import { lazy, Suspense } from 'react';
import { DashboardLayout } from '@repo/ui/components/dashboard-layout';

const VisitesManagement = lazy(() =>
  import('@repo/ui/features/visites/index').then((mod) => ({ default: mod.VisitesManagement })),
);

export default function VisitesPage() {
  return (
    <Suspense fallback={<DendromapLoader message="Chargement des alertes..." />}>
      <VisitesManagement />
    </Suspense>

  );
}

